import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayIsNotEmpty',
  standalone: true, // Optional: if you're using standalone pipes
})
export class ArrayIsNotEmptyPipe implements PipeTransform {
  public transform<T>(value: readonly T[] | null | undefined): boolean {
    return Array.isArray(value) && value.length > 0;
  }
}
